import { convert } from "../../../utils/currency";
import { formatCurrency } from "../../../utils/intl";
import { ProductBarChartValueFormatter } from "./types";

export const DEFAULT_CURRENCY_FORMATTER: ProductBarChartValueFormatter = {
  formatYAxisTick: (v) =>
    new Intl.NumberFormat("id-ID").format(v / 1_000_000_000),
  formatTooltipValue: (numericValue, sample) => {
    if (typeof sample === "number") return String(numericValue);
    return formatCurrency(
      convert({ ...sample, displayAmount: String(numericValue) })
    );
  },
  emptyDomainMax: 1_000_000_000,
};
